var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row", attrs: { id: "top" } }, [
          _c(
            "div",
            { staticClass: "col text-center" },
            [
              _c("router-link", { staticClass: "logo", attrs: { to: "/" } }, [
                _c("img", {
                  attrs: { src: "/images/logo.png", alt: "De Duursportcoach" }
                })
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "navigation-toggle d-inline d-lg-none",
                  on: { click: _vm.toggleNavigation }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        "aria-hidden": "true",
                        focusable: "false",
                        "data-prefix": "fas",
                        "data-icon": "bars",
                        role: "img",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 448 512"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          fill: "currentColor",
                          d:
                            "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                        }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.showNavigation
                ? _c(
                    "nav",
                    { staticClass: "navbar navbar-expand-lg navbar-dark" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "collapse navbar-collapse",
                          attrs: { id: "navigation" }
                        },
                        [
                          _c("ul", { staticClass: "navbar-nav ml-auto" }, [
                            _c("li", { staticClass: "nav-item active" }, [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "smooth-scroll",
                                      rawName: "v-smooth-scroll"
                                    }
                                  ],
                                  staticClass: "nav-link",
                                  attrs: { href: "#wie-ben-ik" }
                                },
                                [_vm._v("Wie ben ik")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "smooth-scroll",
                                      rawName: "v-smooth-scroll"
                                    }
                                  ],
                                  staticClass: "nav-link",
                                  attrs: { href: "#voor-wie" }
                                },
                                [_vm._v("Voor wie")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "smooth-scroll",
                                      rawName: "v-smooth-scroll"
                                    }
                                  ],
                                  staticClass: "nav-link",
                                  attrs: { href: "#inhoud" }
                                },
                                [
                                  _vm._v(
                                    "Inhoud\n                                        trainingsbegeleiding"
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "smooth-scroll",
                                      rawName: "v-smooth-scroll"
                                    }
                                  ],
                                  staticClass: "nav-link",
                                  attrs: { href: "#diensten" }
                                },
                                [_vm._v("Overige diensten")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "smooth-scroll",
                                      rawName: "v-smooth-scroll"
                                    }
                                  ],
                                  staticClass: "nav-link",
                                  attrs: { href: "#contact" }
                                },
                                [_vm._v("Contact")]
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("main", { staticClass: "pt-lg-5", attrs: { role: "main" } }, [
      _c("section", { attrs: { id: "home" } }, [
        _c("div", { staticClass: "container-wrapper-white" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col pt-5 pb-5" }, [
                _c("h1", { staticClass: "text-blue" }, [
                  _vm._v("Het gaat er niet om de beste te zijn,"),
                  _c("br"),
                  _vm._v(
                    "\n                                maar om elke dag beter worden.\n                            "
                  )
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "text-blue" }, [
                  _vm._v("(Esther Vergeer)")
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-wrapper-red", attrs: { id: "wie-ben-ik" } },
          [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-12 col-md-6 col-image order-2 order-md-1"
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/images/wie-ben-ik.png",
                        alt: "Hans Romers"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-6 pt-5 pb-4 text-white order-1 order-md-2"
                  },
                  [
                    _c("h2", [_vm._v("Wie ben ik?")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n                                Ik ben Hans Romers geboren 6 juli 1974, afgestudeerd\n                                aan de Haagse Academie voor Lichamelijke Opvoeding\n                                in 1996. Tijdens de academie gespecialiseerd in\n                                inspanningsfysiologie onder leiding van Jos Geijsel en\n                                Adrie van Diemen.\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("\n                                Vanaf mijn 16"),
                      _c("sup", [_vm._v("de")]),
                      _vm._v(" t/m 22"),
                      _c("sup", [_vm._v("ste")]),
                      _vm._v(
                        " actief geweest in de triatlonsport.\n                                Door een blessure noodgedwongen gestopt en in het\n                                wielrennen terecht gekomen. Naast zelf actief wielrennen\n                                startte ik met het begeleiden van triatleten en wielrenners.\n                                Dit deed ik naast mijn baan als docent aan de opleiding\n                                ROC Mondriaan Lifestyle Sport en Bewegen. Hier ben ik docent\n                                trainingsleer en Gezonde Leefstijl. Sinds 2019 ben ik begonnen\n                                met mijn bedrijf De Duursportcoach en begeleid ik met\n                                veel passie mijn sporters.\n                            "
                      )
                    ])
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container-wrapper-white" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col pt-5 pb-5 text-right" }, [
                _c("h1", { staticClass: "text-blue" }, [
                  _vm._v("Het wordt nooit makkelijker,"),
                  _c("br"),
                  _vm._v(
                    "\n                                je gaat gewoon sneller!"
                  )
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "text-blue" }, [
                  _vm._v("(Greg Lemond)")
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "container-wrapper-yellow",
            attrs: { id: "voor-wie" }
          },
          [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 pt-5 pb-5 text-blue" },
                  [
                    _c("h2", [_vm._v("Voor wie is de trainingsbegeleiding?")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n                                Voor wielrenners, triatleten en hardlopers.\n                                Van recreant tot topsporter die professioneel\n                                begeleid willen worden waarbij balans centraal staat.\n                                Balans tussen belasting die je jezelf oplegt en de\n                                belastbaarheid die je lichaam aankan. Door goed\n                                evenwicht tussen inspanning en herstel zal je\n                                vorderingen maken en je doelen bereiken.\n                            "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6 col-image" }, [
                  _c("img", {
                    attrs: {
                      src: "/images/voor-wie.png",
                      alt: "Voor wie is de trainingsbegeleiding?"
                    }
                  })
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container-wrapper-white" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col pt-5 pb-5" }, [
                _c("h1", { staticClass: "text-blue" }, [
                  _vm._v("Ik begeleid wielrenners,"),
                  _c("br"),
                  _vm._v(
                    "\n                                triatleten en hardlopers.\n                            "
                  )
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "text-blue" }, [
                  _vm._v("(Hans Romers)")
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-wrapper-green", attrs: { id: "inhoud" } },
          [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-12 col-md-6 col-image order-2 order-md-1"
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/images/inhoud.png",
                        alt: "Inhoud trainingsbegeleiding"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-6 pt-5 pb-5 text-white order-1 order-md-2"
                  },
                  [
                    _c("h2", [_vm._v("Inhoud trainingsbegeleiding")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n                                Begeleiding op maat staat centraal. Voorafgaand aan de\n                                begeleiding houden we een intakegesprek om beginsituatie\n                                en doelen vast te stellen. Wekelijks of tweewekelijks of\n                                maandelijks contact om trainingsschema’s te evalueren en\n                                vooruit te kijken naar de toekomstige trainingsperiode.\n                                Daarnaast zullen we periodiek testen om vooruitgang te meten.\n                                De trainingsschema’s worden gemaakt met behulp van\n                                Trainingpeaks, via dit programma analyseer ik de trainingen\n                                en breng jouw ontwikkelingen in kaart. Zo kan ik jou\n                                goed volgen en trainingen bijstellen waar nodig.\n                            "
                      )
                    ])
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "container-wrapper-white" }, [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col pt-5 pb-5 text-right" }, [
                _c("h1", { staticClass: "text-blue" }, [
                  _vm._v("Het lijkt altijd onmogelijk"),
                  _c("br"),
                  _vm._v(
                    "\n                                totdat het is gedaan.\n                            "
                  )
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "text-blue" }, [
                  _vm._v("(Nelson Mandela)")
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-wrapper-blue", attrs: { id: "diensten" } },
          [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col pt-5 pb-5 text-white" }, [
                  _c("h2", [_vm._v("Overige diensten")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                                Naast het maken van trainingsschema’s begeleid ik ook mensen die een gezondere\n                                leefstijl\n                                willen bereiken en geef ik\n                                trainingen en workshops op afspraak.\n                                "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [_vm._v("Voorbeelden van workshops/trainingen")]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [_vm._v("Achtergronden van trainen:")]),
                    _c("br"),
                    _vm._v(
                      "\n                                Leren toepassen van de verschillende trainingsmethodes, balans tussen\n                                belasting/belastbaarheid, periodisering."
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        "Duursportvoedingsadvies en voedingsvoorlichtingvoorlichting:"
                      )
                    ]),
                    _c("br"),
                    _vm._v(
                      "\n                                Wat moet je eten, hoeveel en wanneer?\n                                "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [_vm._v("Coaching on the job:")]),
                    _c("br"),
                    _vm._v(
                      "\n                                Samen trainen met directe feedback: op juiste manier uitvoeren trainingsmethodes,\n                                testen,\n                                rijvaardigheidstraining en\n                                loopscholing.\n                                "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        "Begeleiding van een groepsrit met uw bedrijf of vriendengroep:"
                      )
                    ]),
                    _c("br"),
                    _vm._v(
                      "\n                                Zin in een leuke tocht met je collega’s of vrienden met voorafgaand/na afloop info\n                                over\n                                trainen/voeding. En tijdens de rit\n                                indien gewenst rijvaardigheidstraining in een groep.\n                                "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [_vm._v("Beweegcoach:")]),
                    _c("br"),
                    _vm._v(
                      "\n                                Wil je fitter worden, verzorg ik ook trainingen op maat, dit doe ik buiten. Samen\n                                aan\n                                de slag om meer kracht te krijgen, een beter uithoudingsvermogen en zo een stuk\n                                gezonder te worden. Hiernaast ook de\n                                mogelijkheid om aan ontspanning te werken. Samen op weg naar een gezondere\n                                leefstijl!\n                            "
                    )
                  ])
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-wrapper-white", attrs: { id: "contact" } },
          [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col pt-5 pb-5 text-blue" }, [
                  _c("h2", [_vm._v("Contact")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                                Voor meer informatie en kosten kun je contact opnemen met:"
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v(
                      "\n\n                                De Duursportcoach"
                    ),
                    _c("br"),
                    _vm._v("\n                                Hans Romers"),
                    _c("br"),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "text-blue",
                        attrs: { href: "mailto:hansromers@gmail.com" }
                      },
                      [_vm._v("hansromers@gmail.com")]
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "text-blue",
                        attrs: { href: "tel:+31611275882" }
                      },
                      [_vm._v("+316 112 758 82")]
                    )
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }